import { useLocation } from "react-router-dom";
import type { ReactNode } from "react";

/**
 * RouteFade — enter-only page transition.
 * Keyed on pathname so React remounts on every route change,
 * triggering the CSS `.page-enter` animation exactly once per route.
 *
 * No overlay, no scroll-lock, no exit animation. Route renders instantly,
 * then settles in over ~380ms. Reduced-motion is handled in CSS.
 */
export default function RouteFade({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-enter">
      {children}
    </div>
  );
}